import { render, staticRenderFns } from "./otherAddToCart.vue?vue&type=template&id=23183ed7&scoped=true&"
import script from "./otherAddToCart.vue?vue&type=script&lang=js&"
export * from "./otherAddToCart.vue?vue&type=script&lang=js&"
import style0 from "./otherAddToCart.vue?vue&type=style&index=0&id=23183ed7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23183ed7",
  null
  
)

export default component.exports